/**
 * The controls on a report card: which business it is read as, and whether
 * products fold into their families.
 *
 * Per report, as agreed with Puneet and Kura: the MRR reads all of Rare while
 * another report reads Strategic Development only. Both are saved on the report,
 * and they are left out of the PDF, where a dropdown is just a picture of a
 * dropdown: the cut is stated in the filters line under each report instead. A pack that is already one team's, such as the Hemisphere Education
 * dashboard, hides the team control and reads every report as that team.
 */
export default function ReportControls({
  teams = [],
  team = "all",
  groupProducts = false,
  showGroupProducts = false,
  showTeam = true,
  onChange,
  busy = false,
}) {
  if (!onChange) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-3 text-xs text-[#4a5b68] print:hidden"
      data-testid="report-controls"
    >
      {showTeam && (
      <label className="flex items-center gap-1.5">
        <span className="font-semibold uppercase tracking-[0.1em] text-[#7d8b96]">Team</span>
        <select
          value={team || "all"}
          disabled={busy}
          onChange={(event) => onChange({ team: event.target.value })}
          className="rounded-full border border-[#cccccc] bg-white px-2.5 py-0.5 text-xs text-[#323c44] hover:border-[#7d8b96] focus:border-[#57c1a9] focus:outline-none"
        >
          {(teams.length ? teams : [{ value: "all", label: "All" }]).map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      )}
      {showGroupProducts && (
        <label className="flex items-center gap-1.5">
          <input
            type="checkbox"
            checked={Boolean(groupProducts)}
            disabled={busy}
            onChange={(event) => onChange({ group_products: event.target.checked })}
            className="accent-[#57c1a9]"
          />
          <span>Group products</span>
        </label>
      )}
    </div>
  );
}
